import script from "./saleroom.vue?vue&type=script&setup=true&lang=js"
export * from "./saleroom.vue?vue&type=script&setup=true&lang=js"

import "./saleroom.vue?vue&type=style&index=0&id=56471d12&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56471d12"]])

export default __exports__